export default __webpack_public_path__ + "static/media/PrivateEvents.2323441c.jpg";